module.exports = __webpack_public_path__ + "cb2395b8f2f97268e97b2d76589a1918.jpg";